<template>
  <div>
    <b-card-body>
      <b-card class="user-password">
        <b-form submit.stop.prevent="save">
          <!-- <p><b>Simulador - Configuração de comunicação</b></p>
          <BR /> -->
          <b-row>
            <b-col sm="12">
              <b-form-group :label="$t('primaryIP')" label-for="ip-primary">
                <b-form-input
                  class="input-pentagro"
                  id="ip-primary"
                  type="text"
                  v-model="config.primaryIP"
                  name="validateIPPrimary"
                  v-validate="{
                    required: true,
                  }"
                  :state="validateState('validateIPPrimary')"
                  aria-describedby="validateIPPrimary-feedback"
                  :data-vv-as="$t('primaryIPMessage')"
                  :placeholder="$t('placeholderPrimaryIP')"
                />
                <b-form-invalid-feedback id="validateIPPrimary-feedback">{{
                  veeErrors.first("validateIPPrimary")
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('secondaryIP')" label-for="ip-secundary">
                <b-form-input
                  class="input-pentagro"
                  id="ip-secundary"
                  type="text"
                  v-model="config.secundaryIP"
                  name="validateIPSecundary"
                  v-validate="{
                    required: true,
                  }"
                  :state="validateState('validateIPSecundary')"
                  aria-describedby="validateIPSecundary-feedback"
                  :data-vv-as="$t('secondaryIPMessage')"
                  :placeholder="$t('placeholderSecondayIP')"
                />
                <b-form-invalid-feedback id="validateIPSecundary-feedback">{{
                  veeErrors.first("validateIPSecundary")
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('port')" label-for="port">
                <b-form-input
                  class="input-pentagro"
                  id="port"
                  type="numeric"
                  v-model="config.port"
                  name="validatePort"
                  v-validate="{
                    required: true,
                    min_value: 0,
                    max_value: 65535,
                    numeric: true,
                  }"
                  :state="validateState('validatePort')"
                  aria-describedby="validatePort-feedback"
                  :data-vv-as="$t('portMessage')"
                  :placeholder="$t('placeholderPort')"
                />
                <b-form-invalid-feedback id="validatePort-feedback">{{
                  veeErrors.first("validatePort")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="groupBtn">
            <div>
              <img
                src="@/assets/salvar.png"
                alt="salvar"
                style="margin-left: 30px"
                :title="$t('save')"
                @click="save"
              />
              <img
                src="@/assets/atualizar.png"
                style="margin-left: 30px"
                :title="$t('clear')"
                alt="limpar"
                @click="resetForm"
              />
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/sair.png"
                style="margin-left: 30px"
                :title="$t('exit')"
                alt="Sair"
                @click="$bvModal.hide('modalSimulatorConfig')"
              />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "SimulatorConfig",
  data: function () {
    return {
      config: {
        primaryIP: "127.0.0.1",
        secundaryIP: "127.0.0.1",
        port: 8888,
      },
      backupConfig: {},
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    save() {
      /* eslint-disable */
      this.$validator.validateAll().then((result) => {
        if (!result) {
          showError(this.$t("campos-com-preenchimento-obrigatorio"));
          return;
        } else {
          // console.log("Config: ", this.config);
          axios["post"](
            `${urlMainAPI}/savesimulatorconfiguration/`,
            this.config
          ) //axios ... método chamado por string
            .then((res) => {
              // console.log('ConfigAntesResetForm', this.config)
              this.$nextTick(() => {
                this.$validator.reset();
              });
              //this.$toasted.global.defaultSuccess();
              defaultSuccess(res.data);
              this.backupConfig = { ...this.config };
            })
            .catch(() => {
              this.resetForm();
            });
          // }
        }
      });
    },
    loadSimulatorConfig() {
      const url = `${urlMainAPI}/getsimulatorconfiguration`;
      axios.get(url).then((res) => {
        this.config = res.data;
        this.backupConfig = { ...res.data };
        this.$nextTick(() => {
          this.$validator.reset();
        });
        // console.log('ConfigSimulator', this.config)
        // console.log('ConfigSimulator - Backup', this.backupConfig)
      });
    },
    resetForm() {
      this.$nextTick(() => {
        this.$validator.reset();
      });
      this.reset();
    },
    reset() {
      this.config.primaryIP = this.backupConfig.primaryIP;
      this.config.secundaryIP = this.backupConfig.secundaryIP;
      this.config.port = this.backupConfig.port;
    },
  },
  created() {
    this.$validator.localize("pt_BR");
    this.loadSimulatorConfig();
  },
};
</script>

<style scoped>
.user-password {
  max-width: 600px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img {
  max-height: 35px;
}
</style>
